import React from 'react';
import {TalentProfile} from "../profiles/TalentProfilePage";
import {Route, Routes} from "react-router-dom";
import {useTalentPool} from "../../providers/TalentPoolProvider";
import PageNotFound from "../../components/errors/PageNotFound";
import LoadingBanner from "../../components/LoadingBanner";

const TalentPoolProfile = (props) => {

    const {
        isLoading,
        talentPool,
        searchCriteria
    } = useTalentPool();

    return (
        <Routes>
            <Route path={'talent-profiles/:profileId/*'} element={
                isLoading ?
                    (
                        <div className="flex flex-col items-center justify-center">
                            <LoadingBanner/>
                        </div>
                    ) :
                    <TalentProfile criteria={searchCriteria} browseResults={talentPool?.talent_users}/>
            }/>
            <Route path="*" element={<PageNotFound/>}/>
        </Routes>
    )
};

export default TalentPoolProfile;